import React, { Suspense } from 'react'
import PropTypes from 'prop-types'

import DualLayout from 'layouts/DualLayout'
import BackButton from 'components/BackButton'

import styles from './AboutUs.module.sass'

const LazyLoadImage = React.lazy(() =>
  import('react-lazy-load-image-component').then(module => ({
    default: module.LazyLoadImage
  }))
)

const ACCREDITATION_LOGOS = [
  {
    key: 'accme',
    href: 'https://accme.org',
    src: 'https://c.answersincme.com/corporate/images/accme.png',
    alt: 'accme-logo'
  },
  {
    key: 'ebac',
    href: 'https://www.ebac-cme.org',
    src: 'https://c.answersincme.com/corporate/images/ebac.png',
    alt: 'ebac-logo'
  },
  {
    key: 'gcmep',
    href: 'https://gcmep.org',
    src: 'https://c.answersincme.com/corporate/images/gcmep.png',
    alt: 'gcmep-logo'
  }
]

const AccreditationLogoLink = ({ href, src, alt }) => (
  <a href={href} target="_blank" rel="noopener noreferrer">
    <Suspense fallback={null}>
      <LazyLoadImage
        src={src}
        effect="opacity"
        alt={alt}
        className={styles.img}
      />
    </Suspense>
  </a>
)

AccreditationLogoLink.propTypes = {
  href: PropTypes.string.isRequired,
  src: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired
}

const AboutUs = () => {
  return (
    <DualLayout loading={false} disableLottie>
      <div className={styles.box}>
        <h1>ABOUT US</h1>
        <p>
          Answers in CME (AiCME) is a multi-accredited independent medical
          education provider dedicated to delivering succinct, short-format
          educational activities that connect healthcare professionals with
          dynamic clinical content. We leverage cognitive learning principles
          and innovative instructional techniques to present clinical science in
          a manner that is engaging, informative, and impactful. Our aim is to
          be a trusted provider of high-quality, evidence-based continuing
          medical educational activities that help healthcare professionals to
          stay current with the latest advances in their fields and improve
          their clinical skills.
        </p>
        <p>
          At AiCME, we are committed to enhancing the learning experience and
          improving the quality of education across various therapeutic areas
          through proprietary artificial intelligence. By narrowing the
          knowledge gap and increasing clinician competence, our program
          supports practice improvements that help patients live longer,
          healthier, better-quality lives.
        </p>
        <p>
          AiCME is pleased to hold accreditations from both the Accreditation
          Council for Continuing Medical Education (ACCME) and the European
          Board for Accreditation of Continuing Education for Health
          Professionals (EBAC). Additionally, we are a proud member of the Good
          CME Practice Group (gCMEp).
        </p>
        <p className={styles.hideMobile}>
          <br />
          <br />
        </p>
        <div className={styles.logos}>
          {ACCREDITATION_LOGOS.map(({ key, href, src, alt }) => (
            <AccreditationLogoLink key={key} href={href} src={src} alt={alt} />
          ))}
        </div>

        <BackButton style={{ marginTop: '40px' }} />
      </div>
    </DualLayout>
  )
}

export default AboutUs
